import React from 'react';
import styled from 'styled-components';

const Row = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  margin: 2px 0 4px;
`;

const Checkbox = styled.input`
  margin-top: 2px;
  accent-color: #00f5ff;
  cursor: pointer;
  flex-shrink: 0;
`;

const Text = styled.span`
  font-size: 0.88rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.78);
`;

function KeepSignedInField({ checked, onChange, id = 'keep-signed-in' }) {
  return (
    <Row htmlFor={id}>
      <Checkbox
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <Text>Keep me signed in on this device</Text>
    </Row>
  );
}

export default KeepSignedInField;
